module.exports = __webpack_public_path__ + "09c913791ef75795ddb1ccffe8937cdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/poster.jpg
// module id = 692
// module chunks = 0